import { Link } from "react-router-dom";
import { Github, Linkedin, Twitter, Heart } from "lucide-react";
import { SITE } from "@/data/site";

const COLUMNS = [
    {
        title: "Produkt",
        links: [
            { label: "Funkcje", href: "/features" },
            { label: "Cennik", href: "/pricing" },
            { label: "AI", href: "/ai" },
            { label: "Pobierz", href: "/download" },
        ],
    },
    {
        title: "Firma",
        links: [
            { label: "Blog", href: "/blog" },
            { label: "Funkcje", href: "/features" },
            { label: "Cennik", href: "/pricing" },
        ],
    },
    {
        title: "Prawne",
        links: [
            { label: "Polityka prywatności", href: "/polityka-prywatnosci" },
            { label: "Regulamin", href: "/regulamin" },
        ],
    },
    {
        title: "Kontakt",
        links: [{ label: "Wkrótce", href: null }],
    },
];

export default function Footer() {
    return (
        <footer className="border-t border-border bg-gr-surface2 dark:bg-gr-dsurface">
            <div className="container-gr grid gap-10 py-16 md:grid-cols-5">
                <div className="md:col-span-1">
                    <Link to="/" className="flex items-center gap-2 font-heading text-xl font-extrabold text-primary">
                        <span aria-hidden>💰</span>
                        <span>{SITE.name}</span>
                    </Link>
                    <p className="mt-4 max-w-xs text-sm text-muted-foreground">{SITE.slogan}. Aplikacja księgowa dla JDG i freelancerów.</p>
                </div>
                {COLUMNS.map((col) => (
                    <div key={col.title}>
                        <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-foreground">{col.title}</h3>
                        <ul className="mt-4 space-y-3">
                            {col.links.map((l) => (
                                <li key={l.label}>
                                    {l.href === null ? (
                                        <span className="text-sm text-muted-foreground">{l.label}</span>
                                    ) : l.href.startsWith("mailto:") ? (
                                        <a href={l.href} className="text-sm text-muted-foreground transition-colors hover:text-foreground">
                                            {l.label}
                                        </a>
                                    ) : (
                                        <Link to={l.href} className="text-sm text-muted-foreground transition-colors hover:text-foreground">
                                            {l.label}
                                        </Link>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
            <div className="border-t border-border">
                <div className="container-gr flex flex-col items-center justify-between gap-4 py-6 sm:flex-row">
                    <p className="text-sm text-muted-foreground">© {new Date().getFullYear()} {SITE.name}. Wszelkie prawa zastrzeżone.</p>
                    <p className="flex items-center gap-1.5 text-sm text-muted-foreground">
                        Made with <Heart className="h-4 w-4 fill-error text-error" /> in Poland 🇵🇱
                    </p>
                    <div className="flex items-center gap-4">
                        <a href="#" aria-label="Twitter" className="text-muted-foreground transition-colors hover:text-foreground"><Twitter className="h-5 w-5" /></a>
                        <a href="#" aria-label="LinkedIn" className="text-muted-foreground transition-colors hover:text-foreground"><Linkedin className="h-5 w-5" /></a>
                        <a href="#" aria-label="GitHub" className="text-muted-foreground transition-colors hover:text-foreground"><Github className="h-5 w-5" /></a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
